/*!
 * Copyright © 2020-2023. Verizon Connect Ireland Limited. All rights reserved.
 */

export const ROUTE_PARAMS = {
  SCHEDULER: {
    VEHICLE_ID: 'vehicleId'
  },
  REPLAY: {
    ROUTE: 'replay',
    VEHICLE_ID: 'id',
    NON_POWERED_ASSET_ID: 'nonpoweredassetid',
    START: 'start',
    PRESELECT_SEGMENT_TIME: 'preselectSegmentTime',
    MINIMUM_STOP_DURATION: 'minimumStopDuration',
    MINIMUM_IDLE_DURATION: 'minimumIdleDuration',
    SHOW_IDLE_SEGMENTS: 'showIdleSegments'
  },
  TextView: {
    ROUTE: 'textview'
  },
  FeatureToggles: {
    Enabled: 'featureTogglesEnable',
    Disabled: 'featureTogglesDisable'
  },
  DeviceHealthCheck: {
    DEVICE_HEALTH_CHECK_ID: 'deviceHealthCheckVehicleId'
  },
  PLACE: {
    EDIT_ROUTE: 'editPlace',
    CREATE_ROUTE: 'createPlace',
    GEOFENCE_ID: 'geofenceId',
    SUGGESTED_GEOFENCE_ID: 'suggestedGeofenceId',
    LAT: 'lat',
    LNG: 'lng'
  },
  MANAGE_SPEED: {
    ROUTE: 'manage-speed',
    LAT: 'lat',
    LNG: 'lng',
    SOURCE: 'source'
  }
};
